import { useEffect, useState } from "react";

export const TZ = "Australia/Brisbane";
export const W = 1920;
export const H = 1080;

export const PERIODS = [
  { key: "today", label: "Today" },
  { key: "7d", label: "7 days" },
  { key: "30d", label: "30 days" },
  { key: "all", label: "All time" },
];

export const C = { green: "#73bf44", gold: "#d9b45b", sky: "#38bdf8", amber: "#f59e0b", red: "#ef4444", muted: "#525252", white: "#f5f5f5" };

export const num = (v) => (v == null ? "—" : Number(v).toLocaleString("en-AU"));
export const pct = (v) => (v == null ? "—" : `${v}%`);

export function aud(v, cents = false) {
  if (v == null) return "—";
  return Number(v).toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: cents ? 2 : 0, maximumFractionDigits: cents ? 2 : 0 });
}

export const audShort = (v) => (v >= 1000 ? `$${(v / 1000).toLocaleString("en-AU", { maximumFractionDigits: 1 })}k` : aud(v));

export function hourLabel(h) {
  const n = h % 12 === 0 ? 12 : h % 12;
  return `${n}${h < 12 ? "am" : "pm"}`;
}

export const fmtDay = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString("en-AU", { day: "numeric", month: "short" });
export const fmtClock = (ms) => new Date(ms).toLocaleTimeString("en-AU", { timeZone: TZ, hour: "numeric", minute: "2-digit" });
export const fmtDate = (ms) => new Date(ms).toLocaleDateString("en-AU", { timeZone: TZ, weekday: "long", day: "numeric", month: "long", year: "numeric" });

export function timeAgo(iso, now = Date.now()) {
  if (!iso) return "never";
  const s = Math.max(0, Math.round((now - new Date(iso).getTime()) / 1000));
  if (s < 45) return "just now";
  if (s < 3600) return `${Math.round(s / 60)} min ago`;
  if (s < 86400) return `${Math.round(s / 3600)} h ago`;
  return new Date(iso).toLocaleDateString("en-AU", { timeZone: TZ, day: "numeric", month: "short" });
}

export function useNow(ms = 1000) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(id);
  }, [ms]);
  return now;
}

export const tooltipStyle = {
  contentStyle: { backgroundColor: "#0F0F0F", border: "1px solid #262626", borderRadius: 8, fontSize: 12 },
  labelStyle: { color: "#fff", fontWeight: 600, marginBottom: 4 },
  itemStyle: { color: "#d4d4d4", padding: 0 },
  cursor: { fill: "rgba(255,255,255,0.03)" },
};
